import { render, staticRenderFns } from "./product-info.vue?vue&type=template&id=6bb9cc08"
import script from "./product-info.vue?vue&type=script&lang=js"
export * from "./product-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb9cc08')) {
      api.createRecord('6bb9cc08', component.options)
    } else {
      api.reload('6bb9cc08', component.options)
    }
    module.hot.accept("./product-info.vue?vue&type=template&id=6bb9cc08", function () {
      api.rerender('6bb9cc08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/product-info.vue"
export default component.exports